"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLicenceRequirements = exports.LocalLicenceOptionalCountries = exports.LocalLicenceCountries = void 0;
const UnsupportedValueError_1 = __importDefault(require("../../../../util/UnsupportedValueError"));
const country_1 = require("./country");
var LocalLicenceCountries;
(function (LocalLicenceCountries) {
    LocalLicenceCountries["AT"] = "AT";
    LocalLicenceCountries["AU"] = "AU";
    LocalLicenceCountries["CO"] = "CO";
    LocalLicenceCountries["DE"] = "DE";
    LocalLicenceCountries["ES"] = "ES";
    LocalLicenceCountries["FR"] = "FR";
    LocalLicenceCountries["GP"] = "GP";
    LocalLicenceCountries["GR"] = "GR";
    LocalLicenceCountries["HR"] = "HR";
    LocalLicenceCountries["HU"] = "HU";
    LocalLicenceCountries["IE"] = "IE";
    LocalLicenceCountries["IN"] = "IN";
    LocalLicenceCountries["IS"] = "IS";
    LocalLicenceCountries["IT"] = "IT";
    LocalLicenceCountries["MQ"] = "MQ";
    LocalLicenceCountries["MS"] = "MS";
    LocalLicenceCountries["NL"] = "NL";
    LocalLicenceCountries["NO"] = "NO";
    LocalLicenceCountries["PT"] = "PT";
    LocalLicenceCountries["RO"] = "RO";
    LocalLicenceCountries["US"] = "US";
})(LocalLicenceCountries = exports.LocalLicenceCountries || (exports.LocalLicenceCountries = {}));
var LocalLicenceOptionalCountries;
(function (LocalLicenceOptionalCountries) {
    LocalLicenceOptionalCountries["GB"] = "GB";
})(LocalLicenceOptionalCountries = exports.LocalLicenceOptionalCountries || (exports.LocalLicenceOptionalCountries = {}));
const getLicenceRequirements = (country) => {
    let reqs;
    try {
        switch (country) {
            case LocalLicenceCountries.PT:
                reqs = {
                    fields: {
                        number: true,
                        identification_number: true
                    },
                    Component: country_1.TouristLicence,
                    validation: {
                        number: { min: 1 },
                        identification_number: { min: 1 }
                    },
                    fieldAliases: {
                        number: 'Alojamento Local registration number',
                        identification_number: 'Tax number (NIF)'
                    },
                    fieldExplanations: {
                        number: 'Your Alojamento Local registration number is required. E.g. 59683/AL.',
                        identification_number: 'The tax identification number (NIF) of the property owner is required. E.g. PT034967382.'
                    },
                    helpLink: 'https://travelnest.freshdesk.com/support/solutions/articles/101000386401-obtaining-a-tourist-licence-portugal'
                };
                break;
            case LocalLicenceCountries.AU:
            case LocalLicenceCountries.HR:
            case LocalLicenceCountries.IT:
                reqs = {
                    fields: {
                        number: true,
                        identification_number: false
                    },
                    Component: country_1.TouristLicence
                };
                break;
            case LocalLicenceCountries.IE:
                reqs = {
                    fields: {
                        number: false,
                        identification_number: true
                    },
                    Component: country_1.TouristLicence
                };
                break;
            case LocalLicenceCountries.ES:
                reqs = {
                    Component: country_1.TouristLicenceSpain,
                    validation: {
                        number: {
                            min: 1,
                            skipIfOtherFieldValues: {
                                is_in_region_requiring_tourist_licence: false,
                            }
                        },
                        identification_number: { min: 1 },
                        cadastral_reference_number: {
                            min: 20,
                            max: 20,
                            regex: /^([0-9-a-zA-Z]{20})$/
                        },
                    },
                    fieldAliases: {
                        identification_number: 'NIF, NIE or CIF number'
                    },
                    fieldExplanations: {
                        number: 'Your tourist licence number (also know as property registration number) is required.',
                        identification_number: 'The tax identification number of the property owner is required — NIF for a citizen, NIE for a non-citizen, or CIF for a business. E.g. X2930584J.'
                    },
                    helpLink: 'https://travelnest.freshdesk.com/support/solutions/articles/101000386382-obtaining-a-tourist-licence-spain'
                };
                break;
            case LocalLicenceCountries.FR:
            case LocalLicenceCountries.GP:
            case LocalLicenceCountries.MQ:
                reqs = { Component: country_1.LocalLicenceFrance };
                break;
            case LocalLicenceCountries.IN:
                reqs = { Component: country_1.OptionalRegionalTouristLicence };
                break;
            case LocalLicenceCountries.GR:
                reqs = {
                    fields: {
                        number: true,
                        identification_number: false
                    },
                    Component: country_1.TouristLicence,
                    validation: {
                        number: { min: 1 }
                    },
                    fieldAliases: {
                        number: 'AMA registration number or MHTE number'
                    },
                    fieldExplanations: {
                        number: 'AMA registration number (for short term rentals) or your MHTE number (for EOT licences) is required. E.g. AMA00000953767, or MHTE0921K81000321499.',
                    },
                    helpLink: 'https://travelnest.freshdesk.com/support/solutions/articles/101000374950-obtaining-a-tourist-licence-greece'
                };
                break;
            case LocalLicenceCountries.AT:
            case LocalLicenceCountries.CO:
            case LocalLicenceCountries.DE:
            case LocalLicenceCountries.HU:
            case LocalLicenceCountries.IS:
            case LocalLicenceCountries.MS:
            case LocalLicenceCountries.NL:
            case LocalLicenceCountries.NO:
            case LocalLicenceCountries.RO:
            case LocalLicenceCountries.US:
                reqs = {
                    fields: {
                        number: true,
                        identification_number: true
                    },
                    Component: country_1.TouristLicence,
                };
                break;
            case LocalLicenceOptionalCountries.GB:
                reqs = {
                    Component: country_1.LocalLicenceUK,
                };
                break;
            default: throw new UnsupportedValueError_1.default(country);
        }
        return reqs;
    }
    catch (e) {
        // No requirements
        return undefined;
    }
};
exports.getLicenceRequirements = getLicenceRequirements;
//# sourceMappingURL=config.js.map